// Was hardcoded to the local emulator, which only worked for local dev and would have
// silently broken once this app was deployed anywhere else. REACT_APP_API is baked in
// at build time (see .env.production / .env.development) — falls back to the emulator
// URL so `yarn start` with no env file still works exactly as before.
export const API = process.env.REACT_APP_API || 'http://127.0.0.1:5001/unaffected-co/us-central1/api/admin';

export const TAGS = [
    {id: 0, label: "Government"},
    {id: 1, label: "Banking"},
    {id: 2, label: "Church"},
    {id: 3, label: "Corporate"},
    {id: 4, label: 'Tax fraud'},
    {id: 5, label: 'Health'},
    {id: 6, label: 'Money'},
    {id: 7, label: 'Trump'},
    {id: 8, label: 'Billionaires'},
    {id: 9, label: 'International'},
    {id: 10, label: 'Child labor'},
    {id: 11, label: 'Human trafficking'},
    {id: 12, label: 'Drug trafficking'},
    {id: 13, label: 'Environment'}
];
